<template>
  <b-row>
    <b-col cols="12">
      <sim-orders-table />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import SimOrdersTable from './SimOrdersTable.vue'

export default {
  components: {
    BRow,
    BCol,

    SimOrdersTable
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>